import { useEffect, useRef } from 'react';

type HandlerFunction = () => void;

export function useOutsideClick(
  handler: HandlerFunction,
  listenCapturing = true
) {
  const ref = useRef<any | null>(null);
  const touchHandled = useRef(false);

  useEffect(() => {
    function handleClick(e: MouseEvent | Event) {
      if (ref.current && !ref.current.contains(e.target as Node)) {
        if (typeof TouchEvent !== 'undefined' && e instanceof TouchEvent) {
          touchHandled.current = true;
          handler();
        } else if (!touchHandled.current) {
          handler();
        } else {
          touchHandled.current = false;
        }
      }
    }

    function handleTouchStart(e: Event) {
      if (typeof TouchEvent !== 'undefined' && e instanceof TouchEvent) {
        if (ref.current && !ref.current.contains(e.target as Node)) {
          touchHandled.current = true;
          handler();
        }
      }
    }

    document.addEventListener('click', handleClick, listenCapturing);
    document.addEventListener('touchstart', handleTouchStart, listenCapturing);

    return () => {
      document.removeEventListener('click', handleClick, listenCapturing);
      document.removeEventListener('touchstart', handleTouchStart, listenCapturing);
    };
  }, [handler, listenCapturing]);

  return ref;
}
